import React, { ChangeEvent } from 'react';
import { Box, makeStyles, TextField, Typography } from 'housecall-ui';

import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';

const TEXTAREA_MAX_LENGTH = 1000;

export interface Props {
  question: string;
  dataTestId: string;
  questionKey: 'question1' | 'question2';
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}

const useStyles = makeStyles(() => ({
  charCounter: {
    marginLeft: 'auto',
  },
}));

export const TroubleShootingInput = ({ question, dataTestId, questionKey, onChange, value }: Props) => {
  const { charCounter } = useStyles();
  const { state } = useOnlineBookingReducer();

  return (
    <Box mt={2}>
      <Typography gutterBottom variant="body1">
        {question}
      </Typography>
      <Box my={0}>
        <TextField
          value={value || state[questionKey] || ''}
          multiline={false}
          label="Enter your answer"
          data-testid={dataTestId}
          FormHelperTextProps={{
            className: charCounter,
          }}
          error={(state[questionKey] ?? '').length >= TEXTAREA_MAX_LENGTH}
          inputProps={{
            maxLength: TEXTAREA_MAX_LENGTH,
          }}
          fullWidth
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};
